export function todayDateOnly(): string {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

export function toDateOnly(value: string): string {
  return value.slice(0, 10);
}

/** Parse a "YYYY-MM-DD" string as a local-time Date (avoids UTC shift). */
export function parseDateOnly(dateOnly: string): Date {
  return new Date(`${dateOnly}T00:00:00`);
}
 
/** "YYYY-MM" key used to group records by month. */
export function monthKey(dateOnly: string): string {
  return dateOnly.slice(0, 7);
}
 
/** e.g. "Juli 2026" */
export function monthLabel(dateOnly: string): string {
  let date: Date;
  const isoMatch = dateOnly.match(/\d{4}-\d{2}-\d{2}/);
  if (dateOnly.includes('T')) {
    date = new Date(dateOnly);
  } else if (isoMatch) {
    date = parseDateOnly(isoMatch[0]);
  } else {
    // fallback: try to parse as-is
    date = new Date(dateOnly);
  }
  return date.toLocaleDateString("id-ID", {
    month: "long",
    year: "numeric",
  });
}

export function timeLabel(iso: string): string {
  return new Date(iso).toLocaleTimeString("id-ID", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function fullDateLabel(dateOnly: string): string {
  // handle inputs like "2026-07-22 00:02:57 sekaran" or "2026-07-22T00:00:00"
  let date: Date;
  const isoMatch = dateOnly.match(/\d{4}-\d{2}-\d{2}/);
  if (dateOnly.includes('T')) {
    date = new Date(dateOnly);
  } else if (isoMatch) {
    date = parseDateOnly(isoMatch[0]);
  } else {
    // fallback: try to parse as-is
    date = new Date(dateOnly);
  }
  return date.toLocaleDateString("id-ID", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}